import * as React from 'react';

import style from './errorContainer.module.scss';

interface ErrorContainerProps {
  errors: any;
  visible: boolean | string | undefined;
  name: string;
  autoHeight?: boolean;
}

export const ErrorContainer: React.FunctionComponent<ErrorContainerProps> = ({
  errors,
  visible,
  name,
  autoHeight
}) => {
  return (
    <div className={autoHeight ? '' : style.container}>
      {visible ? <div className={style.fieldError}>{errors[name]}</div> : null}
    </div>
  );
};

export default ErrorContainer;
